<template>
  <router-view/>
  <div class="rainbow-glow bottom-glow"></div>
</template>

<style>
html, body, #app {
  height: 100%;
  margin: 0;
  padding: 0;

  background-color: rgb(220, 220, 220);
}

* {
  font-family: "Inconsolata", monospace;
  font-optical-sizing: auto;
  font-weight: 500;
  font-style: normal;
  font-variation-settings: "wdth" 100;
}

.rainbow-glow {
    position: relative;
    z-index: 2;
}

.rainbow-glow:before {
    content: "";
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    height: 100%;
    width: 100%;
    z-index: -1;
    transform: scale(1) translateZ(0);
    filter: blur(15px);
    background: linear-gradient(90deg,red,#ff4500,orange,gold,#ff0,#adff2f,green,#20b2aa,#0ff,#00f,indigo,#8a2be2,#9400d3,#c71585,#ff1493);
    background-size: 200% 200%;
    animation: animateGlow 5.25s linear infinite;
}

@keyframes animateGlow {
    0% {
        background-position: 200% 50%;
    }
    100% {
        background-position: 0 50%;
    }
}

h1 {
  font-size: 30px!important;
}

h2 {
  font-size: 20px!important;
}

h3 {
  font-size: 15px!important;
}

h4 {
  font-size: 10px!important;
}

.bottom-glow {
  position: fixed;
  bottom: 0;
  left: 0;
  right: 0;
  height: 15px;
}

.page-container {
  display: flex;
  flex-direction: column;
  height: 100%;
}


.header {
  display: flex;
  justify-content: center;
  align-items: center;
  height: 10%;

  position: relative;
}

.header > .back {
  position: absolute;
  left: 5px;
  top: 5px
}

.content {
  display: flex;
  justify-content: center;
  align-items: center;
  height: 90%;
}


</style>
